export type UploadedFileMeta = {
  name?: string
  size?: number
  type?: string
}

export type UploadedFileOptions = {
  type?: string
  file?: UploadedFileMeta
}

export type UploadedFile = {
  source: string
  fileLibraryId?: string
  options?: UploadedFileOptions
}

export const normalizeUploadedFile = (file: UploadedFile): UploadedFile => ({
  ...file,
  options: {
    ...(file.options || {}),
    type: file.options?.type || 'local',
    file: file.options?.file,
  },
})
